<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12" class="mb-3">
          <b-button variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
        </b-col>
      </b-row>
      <b-form @submit.prevent="saveItem">
        <b-row>
          <b-col cols="12">
            <b-alert :show="feedback.show" dismissible :variant="feedback.variant" @dismissed="feedback.show = 0"
                     @dismiss-count-down="countDownChanged">
              {{ feedback.text }}
              <ul v-if="errors" class="mt-3">
                <li v-for="error in errors" :key="error">
                  {{ error.toString() }}
                </li>
              </ul>
            </b-alert>
          </b-col>
          <b-col cols="12">
            <b-card no-body>
              <template v-slot:header>
                <span class="pull-left mt-2 mb-2"><strong>Project (ID: {{item.id}})</strong></span>
                <a :href="item.link" target="_blank" class="btn btn-dark pull-right btn-sm">Bekijk project in
                  Salesforce</a>
              </template>
              <b-tabs pills card>
                <b-tab title="Details" active>
                  <b-row>
                    <b-col cols="6">
                      <div class="clearfix">
                        <h5 class="pull-left">Portal details</h5>
                        <b-button class="pull-right" variant="primary" v-if="!editable" @click="editable = true"
                                  size="sm">Bewerken
                        </b-button>
                        <b-button type="submit" variant="success" class="float-right" size="sm"
                                  :disabled="saveButtonDisabled" v-if="editable">Wijzigingen opslaan
                        </b-button>
                        <b-button @click.prevent="cancelEdit" class="float-right mr-3" v-if="editable" size="sm">
                          Annuleren
                        </b-button>
                      </div>
                      <hr>
                      <b-form-group label="Naam" v-if="item.length > 0 " >
                        <b-form-input type="text" required v-model="item.name" disabled></b-form-input>
                      </b-form-group>
                      <b-form-group label="Categorie" v-if="item.length > 0">
                        <b-form-input type="text" required v-model="item.category.name" disabled></b-form-input>
                      </b-form-group>

                      <b-form-group label="Op schema">
                        <b-form-select :options="scheduleOptions" required v-model="item.schedule_state"
                                       :disabled="!editable"></b-form-select>
                      </b-form-group>
                      <b-form-group label="Status">
                        <b-form-select :options="statusOptions" required v-model="item.status"
                                       :disabled="!editable"></b-form-select>
                      </b-form-group>
                      <b-form-group label="Zichtbaar in portaal">
                        <b-form-checkbox switch required v-model="item.visible" :disabled="!editable" value="1"
                                         unchecked-value="0"></b-form-checkbox>
                      </b-form-group>
                      <b-form-group label="Contactpersoon">
                        <b-form-select :options="contacts" required v-model="item.contact_id"
                                       :disabled="!editable"></b-form-select>
                      </b-form-group>
                      <b-form-group label="Omschrijving">
                        <b-form-textarea required v-model="item.description" :disabled="!editable"></b-form-textarea>
                      </b-form-group>
                      <b-form-group label="Post inhoud">
                        <ckeditor required :editor="editor" v-model="item.body" :disabled="!editable" :config="editorConfig"></ckeditor>
                      </b-form-group>
                      <b-form-group label="Locatie">
                        <b-form-input type="text" v-model="item.location" :disabled="!editable" :placeholder="item.key_data[0].data"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Google Maps link">
                        <b-form-input type="text" v-model="item.url_google_maps" :disabled="!editable"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Google Maps zichtbaar in portaal">
                        <b-form-checkbox switch required v-model="item.show_google_maps" :disabled="!editable" value="1"
                                         unchecked-value="0"></b-form-checkbox>
                      </b-form-group>

                      <hr>

                      <b-form-group label="Extra locatie 1">
                        <b-form-input type="text" v-model="item.extra_location1" :disabled="!editable"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Extra locatie 1 - Google Maps link">
                        <b-form-input type="text" v-model="item.extra_location1_maps" :disabled="!editable"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Extra locatie 1 - Google Maps zichtbaar in portaal">
                        <b-form-checkbox switch required v-model="item.extra_location1_maps_show" :disabled="!editable" value="1"
                                         unchecked-value="0"></b-form-checkbox>
                      </b-form-group>

                      <b-form-group label="Extra locatie 2">
                        <b-form-input type="text" v-model="item.extra_location2" :disabled="!editable"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Extra locatie 2 - Google Maps link">
                        <b-form-input type="text" v-model="item.extra_location2_maps" :disabled="!editable"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Extra locatie 2 - Google Maps zichtbaar in portaal">
                        <b-form-checkbox switch required v-model="item.extra_location2_maps_show" :disabled="!editable" value="1"
                                         unchecked-value="0"></b-form-checkbox>
                      </b-form-group>

                      <b-form-group label="Extra locatie 3">
                        <b-form-input type="text" v-model="item.extra_location3" :disabled="!editable"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Extra locatie 3 - Google Maps link">
                        <b-form-input type="text" v-model="item.extra_location3_maps" :disabled="!editable"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Extra locatie 3 - Google Maps zichtbaar in portaal">
                        <b-form-checkbox switch required v-model="item.extra_location3_maps_show" :disabled="!editable" value="1"
                                         unchecked-value="0"></b-form-checkbox>
                      </b-form-group>

                      <b-form-group label="Extra locatie 4">
                        <b-form-input type="text" v-model="item.extra_location4" :disabled="!editable"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Extra locatie 4 - Google Maps link">
                        <b-form-input type="text" v-model="item.extra_location4_maps" :disabled="!editable"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Extra locatie 4 - Google Maps zichtbaar in portaal">
                        <b-form-checkbox switch required v-model="item.extra_location4_maps_show" :disabled="!editable" value="1"
                                         unchecked-value="0"></b-form-checkbox>
                      </b-form-group>

                      <b-form-group label="Extra locatie 5">
                        <b-form-input type="text" v-model="item.extra_location5" :disabled="!editable"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Extra locatie 5 - Google Maps link">
                        <b-form-input type="text" v-model="item.extra_location5_maps" :disabled="!editable"></b-form-input>
                      </b-form-group>
                      <b-form-group label="Extra locatie 5 - Google Maps zichtbaar in portaal">
                        <b-form-checkbox switch required v-model="item.extra_location5_maps_show" :disabled="!editable" value="1"
                                         unchecked-value="0"></b-form-checkbox>
                      </b-form-group>




<!-- Temporary disabled, wil go live with 2nd sprint 2021 -->
<!--                      <table class="table table-hover">-->
<!--                        <thead>-->
<!--                        <tr>-->
<!--                          <td><strong>Vimeo link</strong></td>-->
<!--                          <td></td>-->
<!--                        </tr>-->
<!--                        </thead>-->
<!--                        <tbody>-->

<!--                        <tr v-if="item.project_videos.length > 0" v-for="(video, index) in item.project_videos" :key="video.id" :disabled="!editable">-->

<!--                          <td><b-form-input type="text" v-model="video.url" :disabled="!editable"></b-form-input></td>-->
<!--                          <td><b-button @click="removeVideoField(index);" class="btn btn-sm btn-danger text-white hoverable" :disabled="!editable">Verwijder video</b-button></td>-->
<!--                        </tr>-->
<!--                        <tr>-->
<!--                          <td></td>-->
<!--                          <td><b-button class="btn btn-sm btn-primary text-white hoverable" @click="addVideoField" :disabled="!editable">Voeg video veld toe</b-button></td>-->
<!--                        </tr>-->
<!--                        </tbody>-->
<!--                      </table>-->
                    </b-col>
                    <b-col cols="6">
                      <h5>Salesforce details</h5>
                      <p><em>Laatste synchronisatie op {{ item.sf_date }}</em></p>
                      <hr>
                      <b-form-group label="Project vorm">
                        <b-form-input type="text" required v-model="item.project_form" disabled></b-form-input>
                      </b-form-group>
                      <b-form-group label="Minimum inleg">
                        <b-form-input type="text" required v-model="item.minimal_participation_amount"
                                      disabled></b-form-input>
                      </b-form-group>
                      <b-form-group label="Verwacht ROI per jaar">
                        <b-form-input type="text" required v-model="item.roi_expected" disabled></b-form-input>
                      </b-form-group>
                      <b-form-group label="Participaties geplaatst">
                        <b-form-input type="text" required v-model="item.participations_count" disabled></b-form-input>
                      </b-form-group>
                      <b-form-group label="Eigen vermogen">
                        <b-form-input type="text" required v-model="item.equity_current" disabled></b-form-input>
                      </b-form-group>
                      <b-form-group label="Verwachte vermogensgroei">
                        <b-form-input type="text" required v-model="item.equity_growth_expected"
                                      disabled></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab title="Kerngegevens">
                  <project-key-data :key-data="item.key_data"/>
                </b-tab>
                <b-tab title="Fases">
                  <project-fases :fases="item.fases" :project-id="item.id"/>
                </b-tab>
                <b-tab title="Participaties">
                  <project-participations :participations="item.participations" />
                </b-tab>
                <b-tab title="Updates">
                  <project-updates :updates="item.updates" :project-id="item.id"></project-updates>
                </b-tab>
                <b-tab title="Bestanden">
                  <project-upload v-on:uploadedFiles="updateFiles" @addedVideo="updateVideos" :options="item.project_mediatypes"/>
                  <project-documents v-on:deletedFile="removeFile" @deletedVideo="removeVideo" :featured_image="item.featured_image" :videos="item.project_videos" :images="item.project_images"
                                     :files="item.project_files"/>

                </b-tab>
                <b-tab title="Uitgelicht">
                  <featured-update-upload v-on:uploadedFiles="updateFiles" :options="item.project_mediatypes" />
                  <featured-upload-documents v-on:deletedFile="removeFile" :images="item.project_featured_images" />
                </b-tab>
              </b-tabs>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>
<script>
import {getData, updateData} from '@/api';
import ProjectParticipations from "@/views/projects/parts/Participations";
import ProjectUpdates from "@/views/projects/parts/Updates";
import ProjectKeyData from "@/views/projects/parts/KeyData";
import ProjectFases from "@/views/projects/parts/Fases";
import ProjectUpload from "@/views/projects/parts/Upload";
import ProjectDocuments from "@/views/projects/parts/Documents";
import FeaturedUpdateUpload from "@/views/projects/parts/FeaturedUpload";
import FeaturedUploadDocuments from "@/views/projects/parts/FeaturedDocuments";
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import ClassicEditor from '@/assets/ckeditor5';

export default {
  name: 'project',
  components: {
    ProjectFases,
    ProjectKeyData,
    ProjectUpdates,
    ProjectParticipations,
    ProjectUpload,
    ProjectDocuments,
    FeaturedUpdateUpload,
    FeaturedUploadDocuments,
    ClassicEditor
    },
  props: ['id'],
   mounted: function () {

  },
  data() {
    return {
      saveButtonDisabled: false,
      feedback: {
        show: false,
        text: '',
        variant: null,
        dismissCountDown: 4,

      },
      editor: ClassicEditor,
      editorData: '<p>Content of the editor.</p>',
      editorConfig: {
        toolbar: {
          items: [
            'heading', '|',
            'bold', 'underline', 'italic', 'strikethrough', '|',
            'fontColor', 'fontBackgroundColor', '|',
            'indent', 'outdent', '|',
            'bulletedList', 'numberedList', '|',
            'link',
          ],
          height: '500px',
        },

        indentBlock: {
          offset: 1,
          unit: 'em'
        },

        fontColor: {
          colors: [
            {
              color: 'hsl(0, 0%, 0%)',
              label: 'Black'
            },
            {
              color: 'hsl(0, 0%, 52%)',
              label: 'Dim grey'
            },
            {
              color: 'hsl(19, 98%, 53%)',
              label: 'Orange'
            }
          ]
        }
      },

      statusOptions: [
        {'value': null, 'text': 'Kies een optie...'},
        {'value': 'new', 'text': 'Nieuw'},
        {'value': 'ongoing', 'text': 'Lopend'},
        {'value': 'completed', 'text': 'Afgerond'}
      ],
      scheduleOptions: [
        {'value': null, 'text': 'Kies een optie...'},
        {'value': 'ahead_on_schedule', 'text': 'Voor op schema'},
        {'value': 'on_schedule', 'text': 'Op schema'},
        {'value': 'slight_delay', 'text': 'Licht vertraagd'},
        {'value': 'delayed', 'text': 'Vetraagd'}
      ],
      contacts: [],
      editable: false,
      companyOptions: [],
      countryOptions: [],
      item: {},
      errors: null,
    }
  },

  methods: {
    async getItem() {
      const item = await getData('projects/' + this.$route.params.id).then(response => response.data);

      this.item = item.data;
    },
    async getContacts() {
      this.contacts = await getData('users/select').then(response => response.data);
    },
    async saveItem() {

      this.errors = null;
      this.saveButtonDisabled = true;
      const request = await updateData('projects/' + this.$route.params.id, {
        'description': this.item.description,
        'body': this.item.body,
        'location': this.item.location,
        'url_google_maps': this.item.url_google_maps,
        'show_google_maps': this.item.show_google_maps,

        'extra_location1': this.item.extra_location1,
        'extra_location1_maps': this.item.extra_location1_maps,
        'extra_location1_maps_show': this.item.extra_location1_maps_show,

        'extra_location2': this.item.extra_location2,
        'extra_location2_maps': this.item.extra_location2_maps,
        'extra_location2_maps_show': this.item.extra_location2_maps_show,

        'extra_location3': this.item.extra_location3,
        'extra_location3_maps': this.item.extra_location3_maps,
        'extra_location3_maps_show': this.item.extra_location3_maps_show,

        'extra_location4': this.item.extra_location4,
        'extra_location4_maps': this.item.extra_location4_maps,
        'extra_location4_maps_show': this.item.extra_location4_maps_show,

        'extra_location5': this.item.extra_location5,
        'extra_location5_maps': this.item.extra_location5_maps,
        'extra_location5_maps_show': this.item.extra_location5_maps_show,

        'visible': this.item.visible,
        'schedule_state': this.item.schedule_state,
        'status': this.item.status,
        'contact_id': this.item.contact_id,
        'project_videos': this.item.project_videos.map(function(a) {return a.url;}),
      });
      //  console.log(request);
      if (request.status === 200) {
        this.item = request.data.data;
        this.feedback.show = true;
        this.feedback.text = 'Project succesvol geupdate';
        this.feedback.variant = 'success';
        this.editable = false;
        this.saveButtonDisabled = false;
      } else {
        this.errors = request.data.errors;
        this.feedback.show = true;
        this.feedback.text = 'Er ging iets mis...';
        this.feedback.variant = 'danger';
        this.editable = true;
        this.saveButtonDisabled = false;
      }
    },
    cancelEdit() {
      this.editable = false;
      this.getItem();
    },
    countDownChanged(dismissCountDown) {
      this.feedback.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.this.feedback.dismissCountDown = this.dismissSecs
    },
    updateFiles(data) {
      this.item.project_images = data.project_images;
      this.item.project_files = data.project_files;
      this.item.project_featured_images = data.project_featured_images;
    },
    removeFile(id) {
      this.item.project_images = this.item.project_images.filter(file => {
        return file.id != id;
      })
      this.item.project_files = this.item.project_files.filter(file => {
        return file.id != id;
      })
      this.item.project_featured_images = this.item.project_featured_images.filter(file => {
        return file.id != id;
      })
    },
    addVideoField: function () {
      this.item.project_videos.push({ id: "", url: "" });
    },
    removeVideoField: function (index) {
      this.item.project_videos.splice(index, 1);
    },

    updateVideos(data) {
      this.item.project_videos = data;
    },

    removeVideo(id) {
      this.item.project_videos = this.item.project_videos.filter(video => video.id !== id);
    }

  },
  beforeMount() {
    this.getItem();
    this.getContacts();
    // this.getCountries();
  },


}

</script>

<style  >
.ProseMirror{
  background-color: #fff;
  border: 1px solid #e9e9e9;
    padding: 7px;
    border-radius: 5px;
        color: #5c6873;
}

.ProseMirror:focus {
   color: #5c6873;
}

.ProseMirror:active {
  color: var(--drk-blue);
}
.ProseMirror {
  transition: all 0.3s ease;
}

.ProseMirror:focus {
  outline: none;
  border: 5px solid #b3deee78;
      margin: -5px;
}

.ProseMirror:active {
  color: var(--drk-blue);
}
 .ck-read-only{
   background-color: #e4e7ea  !important;
 }
</style>
